import { render, staticRenderFns } from "./CookieDeclarationRow.vue?vue&type=template&id=70428b1c&"
import script from "./CookieDeclarationRow.vue?vue&type=script&lang=js&"
export * from "./CookieDeclarationRow.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports